import script from "./AiCountdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./AiCountdown.vue?vue&type=script&setup=true&lang=ts"

import "./AiCountdown.scss?vue&type=style&index=0&id=0fa6fd47&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fa6fd47"]])

export default __exports__